import { ProductType } from "./productType.model";

export interface ICategory {
  id?: number;
  name?: string;
  description?: string;
  image?: string;
  kahpooCommision?: number;
  slug?: string;
  autoSaisieCodePaiement?: boolean;
  productTypes?: ProductType
}

export class Category implements ICategory {
  constructor(
    public id?: number,
    public name?: string,
    public description?: string,
    public image?: string,
    public kahpooCommision?: number,
    public slug?: string,
    public autoSaisieCodePaiement?: boolean,
    public productTypes?: ProductType,
  ) {
    this.id = id;
    this.name = name;
    this.description = description;
    this.image = image;
    this.kahpooCommision = kahpooCommision;
    this.slug = slug;
    this.autoSaisieCodePaiement = autoSaisieCodePaiement;
    this.productTypes = productTypes;
  }
}
